/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to import a Gmail thread or specific messages into a claim
 * @export
 * @interface ImportGmailThreadRequest
 */
export interface ImportGmailThreadRequest {
    /**
     * Gmail thread ID to import
     * @type {string}
     * @memberof ImportGmailThreadRequest
     */
    threadId: string;
    /**
     * Optional: specific message IDs to import. If omitted, imports entire thread.
     * @type {Array<string>}
     * @memberof ImportGmailThreadRequest
     */
    messageIds?: Array<string>;
}

/**
 * Check if a given object implements the ImportGmailThreadRequest interface.
 */
export function instanceOfImportGmailThreadRequest(value: object): value is ImportGmailThreadRequest {
    if (!('threadId' in value) || value['threadId'] === undefined) return false;
    return true;
}

export function ImportGmailThreadRequestFromJSON(json: any): ImportGmailThreadRequest {
    return ImportGmailThreadRequestFromJSONTyped(json, false);
}

export function ImportGmailThreadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportGmailThreadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'threadId': json['threadId'],
        'messageIds': json['messageIds'] == null ? undefined : json['messageIds'],
    };
}

export function ImportGmailThreadRequestToJSON(json: any): ImportGmailThreadRequest {
    return ImportGmailThreadRequestToJSONTyped(json, false);
}

export function ImportGmailThreadRequestToJSONTyped(value?: ImportGmailThreadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threadId': value['threadId'],
        'messageIds': value['messageIds'],
    };
}

